import React from "react";
import { connect } from "react-redux";
import * as actions from "../../../actions/actions";

import SignupPageLayout from "./signup-page-layout";
import SignupForm from "./signup-form";
import EduPricing from "../../nounproject-edu-pricing";

let FormSectionContent = ({ redirect }) => {
    const onSuccess = () => {
        redirect("/for-edu/apply/");
    };

    return (
        <div className="dark-theme-wrapper">
            <SignupForm
                onSuccess={onSuccess}
                signupType="basic"
                accentColor="blue"
                next="/for-edu/apply/"
                authPathOverride="/for-edu/login/"
            />
        </div>
    );
};

FormSectionContent = connect(
    null,
    {
        redirect: actions.redirect
    }
)(FormSectionContent);

const EduSignupPage = () => {
    return (
        <SignupPageLayout
            formSectionContent={<FormSectionContent />}
            featuresSectionContent={<EduPricing />}
        />
    );
};

export default EduSignupPage;
